<div class="form-panel__body" [formGroup]="form">

  <!-- ── Page to fetch ─────────────────────────────────────────────── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.target">
    <div class="query-section__header" (click)="toggleSection('target')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="page"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Page to fetch</span>
          <span class="query-section__desc">The URL to fetch</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.target ? 'flex' : 'none'">


      <div class="form-field">
        <label class="form-field__label">Mode</label>
        <div class="seg-control">
          <div class="seg-control__option" [class.seg-control__option--active]="form.value.mode === 'single'" (click)="setMode('single')">
            <div class="seg-control__title">
              <svg class="seg-control__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.58011 1.07656C9.88578 1.22638 10.0522 1.56329 9.98545 1.89709L9.16486 6.00001H13.25C13.5437 6.00001 13.8103 6.17137 13.9323 6.43848C14.0542 6.70559 14.0091 7.0193 13.8168 7.2412L7.31678 14.7412C7.09383 14.9985 6.72559 15.0733 6.41991 14.9235C6.11424 14.7736 5.94781 14.4367 6.01458 14.1029L6.83516 10H2.75001C2.45637 10 2.18974 9.82865 2.06777 9.56154C1.9458 9.29443 1.99093 8.98071 2.18324 8.75881L8.68324 1.25881C8.90619 1.00156 9.27444 0.926728 9.58011 1.07656Z" fill="currentColor"/>
              </svg>
              Single page
            </div>
            <div class="seg-control__desc">Fetch main content of a single webpage from a given URL</div>
          </div>
          <div class="seg-control__option" [class.seg-control__option--active]="form.value.mode === 'subsequent'" (click)="setMode('subsequent')">
            <div class="seg-control__title">
              <svg class="seg-control__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.96544 11.0261C9.13578 11.6382 8.11014 12 7 12C4.23858 12 2 9.76142 2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7C12 8.11014 11.6382 9.13578 11.0261 9.96544L13.7803 12.7197C14.0732 13.0126 14.0732 13.4874 13.7803 13.7803C13.4874 14.0732 13.0126 14.0732 12.7197 13.7803L9.96544 11.0261ZM10.5 7C10.5 8.933 8.933 10.5 7 10.5C5.067 10.5 3.5 8.933 3.5 7C3.5 5.067 5.067 3.5 7 3.5C8.933 3.5 10.5 5.067 10.5 7Z" fill="currentColor"/>
              </svg>
              Subsequent pages
            </div>
            <div class="seg-control__desc">Retrieve the main content of multiple pages following the given URL</div>
          </div>
        </div>
      </div>

      <div class="form-field">
        <label class="form-field__label">Webpage URL<span class="form-field__required">*</span></label>
        <input type="text" class="field-input field-input--text" formControlName="url" placeholder="https://www.cikisi.com/news/depth-look-…-2026-04-28" />
        <a href="#" class="link" style="font-size:12px;line-height:16px;">Learn more about legal framework / copyright</a>
      </div>

    </div>
  </div>

  <!-- ── Access configuration ─────────────────────────────────────────── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.access">
    <div class="query-section__header" (click)="toggleSection('access')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="access"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Access configuration</span>
          <span class="query-section__desc">How the page gets fetched</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.access ? 'flex' : 'none'">

      <div class="form-section__toggle-row">
        <label class="toggle" style="gap:6px;"><input type="checkbox" class="toggle__input" formControlName="residentialIp"><span class="toggle__track"><span class="toggle__thumb"></span></span></label>
        <div class="form-section__toggle-info">
          <span class="form-sublabel">Use residential IP to access the URL</span>
          <span class="form-hint">Avoid bot detection</span>
        </div>
      </div>

      <div class="form-section__toggle-row">
        <label class="toggle" style="gap:6px;"><input type="checkbox" class="toggle__input" formControlName="ipFromUsa"><span class="toggle__track"><span class="toggle__thumb"></span></span></label>
        <div class="form-section__toggle-info">
          <span class="form-sublabel">Use IP from USA</span>
          <span class="form-hint">For geographically restricted content</span>
        </div>
      </div>

      <div class="form-section__toggle-row">
        <label class="toggle" style="gap:6px;"><input type="checkbox" class="toggle__input" formControlName="bypassRobotsTxt"><span class="toggle__track"><span class="toggle__thumb"></span></span></label>
        <div class="form-section__toggle-info">
          <span class="form-sublabel">Bypass robots.txt restrictions</span>
          <span class="form-hint">Law Enforcement &amp; Gov. agencies only</span>
        </div>
      </div>

      <div class="form-section__toggle-row">
        <label class="toggle" style="gap:6px;"><input type="checkbox" class="toggle__input" formControlName="closePopups"><span class="toggle__track"><span class="toggle__thumb"></span></span></label>
        <div class="form-section__toggle-info">
          <span class="form-sublabel">Close pop-ups before access</span>
          <span class="form-hint">Attempt to dismiss modals automatically</span>
        </div>
      </div>

      <div class="form-section__toggle-row">
        <label class="toggle" style="gap:6px;"><input type="checkbox" class="toggle__input" formControlName="headlessBrowser"><span class="toggle__track"><span class="toggle__thumb"></span></span></label>
        <div class="form-section__toggle-info">
          <span class="form-sublabel">Use headless browser</span>
          <span class="form-hint">Render JS content (similar to LinkUp's Render JS)</span>
        </div>
      </div>

      <div class="form-section__toggle-row">
        <label class="toggle" style="gap:6px;"><input type="checkbox" class="toggle__input" formControlName="useCikisiIndex"><span class="toggle__track"><span class="toggle__thumb"></span></span></label>
        <div class="form-section__toggle-info">
          <span class="form-sublabel">Use Cikisi web index</span>
          <span class="form-hint">If URL already indexed</span>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Response configuration collapsed by default: set once, rarely revisited ── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.response">
    <div class="query-section__header" (click)="toggleSection('response')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="response"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Response configuration</span>
          <span class="query-section__desc">Which fields to return per fetched page</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.response ? 'flex' : 'none'">

      <div class="form-field" formGroupName="fields">
        <label class="form-sublabel">Data fields per result</label>
        <p class="form-hint" style="margin-top:-4px;">At least one option must be selected.</p>
        <div class="cb-grid">
          <div class="cb-grid__col">
            @for (f of FIELD_META.slice(0, 6); track f.key) {
              <label class="cb-pill"><input type="checkbox" class="cb-pill__input" [formControlName]="f.key">{{ f.label }}{{ f.required ? ' *' : '' }}</label>
            }
          </div>
          <div class="cb-grid__col">
            @for (f of FIELD_META.slice(6); track f.key) {
              <label class="cb-pill"><input type="checkbox" class="cb-pill__input" [formControlName]="f.key">{{ f.label }}</label>
            }
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
